export default __webpack_public_path__ + "static/media/1792.61c9ff02.png";